<template>
  <div>
    <Treeselect
      :options="options"
      :multiple="true"
      value-consists-of="LEAF_PRIORITY"
      v-model="disciplines"
    />
    <div class="flex items-center justify-end p-4 border-t">
      <button @click="submit">Crear</button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  components: {
    Treeselect,
  },
  props: {
    course: {
      type: String,
    },
  },
  data() {
    return {
      disciplines: null,
    };
  },
  computed: {
    ...mapState(["tabs", "user"]),
    ...mapGetters(["currentTab"]),
    options() {
      const filter = this.currentTab.extras.disciplines.reduce(
        (acc, val, index) => {
          acc[val.grado] = acc[val.grado] || {
            id: val.grado,
            label: val.grado,
            children: [],
          };

          acc[val.grado].children.push({
            id: `${index}.${val.descripcion}`,
            label: val.descripcion,
          });

          return acc;
        },
        {}
      );

      return Array.from(Object.values(filter));
    },
  },
  methods: {
    ...mapMutations(["hideModal"]),
    ...mapActions(["selectTab"]),
    submit() {
      const data = this.disciplines.map((discipline) => {
        return {
          ID_Curso: this.course,
          descripcion: discipline.split(".")[1],
          profesores: "",
          colegio: this.user.colegio,
        };
      });

      axios
        .post("server/index.php", {
          action: "createDisciplines",
          user: this.user.num,
          colegio: this.user.colegio,
          data,
          timestamp: Date.now(),
        })
        .then(() => {
          const disciplineTab = this.tabs.find(
            (tab) => tab.title === "Asignaturas"
          );
          this.hideModal();
          this.selectTab(disciplineTab);
        });
    },
  },
};
</script>
